/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_error_unexpected = /** @type {(inputs: {}) => string} */ () => {
	return `Ha ocurrido un error inesperado`
};

const en_cards_error_unexpected = /** @type {(inputs: {}) => string} */ () => {
	return `An unexpected error occurred`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_error_unexpected = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_error_unexpected(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_error_unexpected", locale)
	if (locale === "es") return es_cards_error_unexpected(inputs)
	return en_cards_error_unexpected(inputs)
};
export { cards_error_unexpected as "cards.error_unexpected" }